export function expandLineItems(order) {
  const items = [];
  let index = 0;
  (order?.line_items || []).forEach((line) => {
    const quantity = Number(line?.current_quantity) || 0;
    for (let i = 0; i < quantity; i += 1) {
      index += 1;
      items.push({
        skuId: `${line.sku}-${index}`,
        line,
      });
    }
  });
  return items;
}

export function availableActions(order, line) {
  const actions = [];
  if (!order?.deadLineDays) {
    actions.push({ value: "Troca", label: "Trocar" });
  }
  if (order?.hasRefund) {
    actions.push({ value: "Devolução", label: "Devolver" });
  }
  if (line?.hasWarranty) {
    actions.push({ value: "Garantia", label: "Garantia" });
  }
  return actions;
}

export function isChosenAction(value) {
  return value === "Troca" || value === "Devolução" || value === "Garantia";
}

export function defaultIncludeAction(order, line) {
  const actions = availableActions(order, line);
  if (line?.hasWarranty && order?.deadLineDays && actions.some((item) => item.value === "Garantia")) {
    return "Garantia";
  }
  return actions.find((item) => item.value === "Devolução")?.value
    || actions.find((item) => item.value === "Troca")?.value
    || actions[0]?.value
    || "Incluir";
}

export function resolveProductAction(line, selectedAction, order) {
  if (isChosenAction(selectedAction)) {
    return selectedAction;
  }
  if (line?.hasWarranty && order?.deadLineDays) {
    return "Garantia";
  }
  return "Devolução";
}

export function inStockVariants(product) {
  return (product?.availableVariants || []).filter((variant) => {
    const quantity = variant.inventoryQuantity ?? variant.inventory_quantity;
    return quantity === undefined || quantity === null || Number(quantity) > 0;
  });
}

export function actionLabel(action) {
  switch (action) {
    case "Troca":
      return "troca";
    case "Devolução":
      return "devolução";
    case "Garantia":
      return "garantia";
    default:
      return "solicitação";
  }
}
